import { Col, Form, Offcanvas } from "react-bootstrap";
import { TextField } from "@fluentui/react";
import IInspeccionObservacion, { IAspectoEvaluar } from "../../../entities/IInspeccionObservacion";
import { useState } from "react";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { cognitoUserInfo } from "../../../helpers/userHelper";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import moment from "moment";
import { dateFormatInputReference, shortDate } from "../../../helpers/dateHelper";
import IUserPickerValue from "../../../entities/helper/IUserPickerValue";
import { E_EstadoTipoEvaluacionLIO } from "../../../enums/E_EstadoTipoEvaluacionLIO";
import UserPickerData from "../../../controls/UserPickerData";
import { API_ADMIN_CONTRATISTA_RESPONSABLE, URL_SUPPORT, API_ADMIN_LIO_PREVENCIONISTA, ROW_COUNT } from "../../../helpers/variableHelper";
import { getAPI } from "../../../helpers/httpHelper";
import { IContratistaResponsable } from "../../../entities/IContratistaResponsable";
import { ITypeWorkComboboxOption } from "../../../entities/helper/IComboboxOption";

interface IAspectoEvaluarProps {
  token: string;
  onClose: () => void;
  selectedLIO: Partial<IInspeccionObservacion>;
  aspectoEvaluar: IAspectoEvaluar | null;
  onSave: (aspectoEvaluado: IAspectoEvaluar) => void;
  tipoFaena: ITypeWorkComboboxOption | null;
}
export default function AspectoEvaluar({ token, onClose, selectedLIO, aspectoEvaluar, onSave, tipoFaena }: IAspectoEvaluarProps) {
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [fechaHasta, setFechaHasta] = useState<string>();
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [lenAccionInc, setLenAccionInc] = useState(0);
  const [accion, setAccion] = useState("");
  const [responsable, setResponsable] = useState<IUserPickerValue | null>(null);
  const [contratistasResponsables, setContratistasResponsables] = useState<IContratistaResponsable[]>([]);
  const [isExternoInspector, setIsExternoInspector] = useState(false);
  usePromiseEffect(async () => {
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    try {
      if (currUser.external && currUser?.roles.IS_EXT_LIO) {
        let params = {
          PAGINA: 1,
          PAGINADO: ROW_COUNT,
          ORDENADOPOR: "ID",
          ORIENTACION: "DESC",
          TITULO: null,
          NOMBRE_INSPECTOR_CONTRATISTA: currUser.email,
          ID_GERENCIA_SUBGERENCIA: null,
          ACTIVO: null,
        };
        let result = (
          await getAPI(`${URL_SUPPORT}${API_ADMIN_LIO_PREVENCIONISTA}/GetAllEmpresaInspectora`, { Authorization: `Bearer ${token}` }, params)
        ).result.data;
        setIsExternoInspector(result.length > 0);
      }
    } catch (error) {}
    if (selectedLIO.GERENCIA_SUBGERENCIA && selectedLIO.CONTRATISTA_SUBCONTRATISTA) {
      let result = (
        await getAPI(
          `${URL_SUPPORT}${API_ADMIN_CONTRATISTA_RESPONSABLE}/getall?PAGINA=1&PAGINADO=10&ORIENTACION=DESC&ORDENADOPOR=ID&GERENCIA=${selectedLIO.GERENCIA_SUBGERENCIA}&CONTRATISTA=${selectedLIO.CONTRATISTA_SUBCONTRATISTA}&ACTIVO=true`,
          { Authorization: `Bearer ${token}` }
        )
      ).result;
      let list = result.data;
      setContratistasResponsables(list);
    }
    if (aspectoEvaluar) {
      setLenAccionInc(aspectoEvaluar.ACCION_REALIZADA?.length || 0);
      setResponsable({ mail: aspectoEvaluar.RESPONSABLE as string, name: aspectoEvaluar.RESPONSABLE_DISPLAY as string });
      setAccion(aspectoEvaluar.ACCION_REALIZADA as string);
      setFechaHasta(aspectoEvaluar.FECHA_HASTA?.toString());
    }
  }, []);
  const callback = (id: any, value: Array<any>) => {
    setResponsable(value?.shift());
  };

  const formValidation = (value: Partial<IAspectoEvaluar>) => {
    let arrErrors: Array<string> = [];

    if (!moment(value.FECHA_HASTA).isValid()) {
      arrErrors.push("FECHA_HASTA");
    }

    if (!value.RESPONSABLE) {
      arrErrors.push("RESPONSABLE");
    }

    if (!tipoFaena?.newFormat && !value.ACCION_REALIZADA) {
      arrErrors.push("ACCION_REALIZADA");
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const handleGuardarAspectoEvaluar = async () => {
    let obj = {
      ...aspectoEvaluar,
      ID: aspectoEvaluar?.ID || null,
      ID_ESTADO: aspectoEvaluar?.ID_ESTADO,
      ACCION_REALIZADA: accion,
      FECHA_HASTA: moment(fechaHasta).toDate(),
      FECHA_ASIGNACION: aspectoEvaluar?.FECHA_ASIGNACION,
      ID_ASPECTO: aspectoEvaluar?.ID_ASPECTO,
      ID_TIPO_EVALUACION: tipoFaena?.newFormat ? E_EstadoTipoEvaluacionLIO.Aplica : E_EstadoTipoEvaluacionLIO.SubEstandar,
      ID_INSPECCION_OBSERVACION: aspectoEvaluar?.ID_INSPECCION_OBSERVACION,
      RESPONSABLE: responsable?.mail,
      RESPONSABLE_DISPLAY: responsable?.name,
      TITULO_ASPECTO: aspectoEvaluar?.TITULO_ASPECTO,
      AUTOR: currentUser?.email as string,
      AUTOR_DISPLAY: currentUser?.name as string,
      EDITOR: aspectoEvaluar?.EDITOR,
      EDITOR_DISPLAY: aspectoEvaluar?.EDITOR_DISPLAY,
      FECHA_CREACION: new Date(),
      FECHA_MODIFICACION: aspectoEvaluar?.FECHA_MODIFICACION,
    };

    if (formValidation(obj)) {
      onSave(obj as IAspectoEvaluar);
    } else {
      return -1;
    }
  };

  return (
    <Offcanvas show={true} onHide={onClose} placement={"end"} className="w-50 modalAgregarCausa">
      <Offcanvas.Header closeButton className="border-bottom">
        <Offcanvas.Title className="m-3 mb-1 colorTit">{tipoFaena?.newFormat ? "Acción" : "Aspecto Evaluar"}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="m-3">
        <button
          data-testid="btnedit"
          hidden={true}
          onClick={() => {
            callback(1, []);
          }}></button>
        {tipoFaena?.newFormat && (
          <div className="row mb-3 p-2 bgAccionNuevoFormato">
            <Col xs="12" md="12" lg="12">
              <span className="me-2 fs-08rem">
                <strong>{"Acción " + aspectoEvaluar?.TITULO}</strong>
              </span>
              <span className="fs-08rem">{aspectoEvaluar?.NOMBRE_ELEMENTO}</span>
            </Col>
          </div>
        )}
        <div className="row mb-2 ajusteInput">
          <Col xs="12" md="6" lg="4">
            <span className="text-danger">
              <strong>(*)</strong>
            </span>
            <label>Responsable:</label>
          </Col>
          <Col xs="12" md="6" lg="8">
            <UserPickerData
              name={"Responsable"}
              callback={callback}
              id={"Responsable"}
              key={"1"}
              multi={false}
              disabled={false}
              className={`${arrErrorEmpty.includes("RESPONSABLE") && "error"} borderColorGris`}
              defaultValue={responsable}
              options={contratistasResponsables.map((cr) => {
                return {
                  mail: cr.RESPONSABLE,
                  name: cr.RESPONSABLE_DISPLAY,
                };
              })}
              currentUser={currentUser}
              isExternoInspector={isExternoInspector}
              showAD={true}
            />
          </Col>
        </div>
        <div className="row mb-2 ajusteInput">
          <Col xs="12" md="6" lg="4">
            <span className="text-danger">
              <strong>(*)</strong>
            </span>
            <label>Fecha hasta:</label>
          </Col>
          <Col xs="12" md="6" lg="8">
            <Form.Control
              onChange={(e) => {
                setFechaHasta(e.target.value);
              }}
              type="date"
              data-testId="datetest"
              defaultValue={
                aspectoEvaluar
                  ? (shortDate(aspectoEvaluar?.FECHA_HASTA, dateFormatInputReference) as string)
                  : (shortDate(fechaHasta, dateFormatInputReference) as string)
              }
              className={`${arrErrorEmpty.includes("FECHA_HASTA") && "error"}`}
              min={moment().format(dateFormatInputReference)}
            />
          </Col>
        </div>
        {!tipoFaena?.newFormat && (
          <div className="row mb-2 ajusteInput">
            <Col xs="12" md="6" lg="4">
              <span className="text-danger">
                <strong>(*)</strong>
              </span>
              <label>Acción:</label>
            </Col>
            <Col xs="12" md="6" lg="8">
              <div>
                <TextField
                  multiline
                  data-testId="textbox"
                  className={`${arrErrorEmpty.includes("ACCION_REALIZADA") && "error"} borderGris`}
                  onChange={(e) => {
                    setLenAccionInc((e as React.ChangeEvent<HTMLTextAreaElement>).target.value.length);
                    setAccion((e as React.ChangeEvent<HTMLTextAreaElement>).target.value);
                  }}
                  defaultValue={aspectoEvaluar?.ACCION_REALIZADA || ""}
                  maxLength={250}></TextField>
                <span>{lenAccionInc}/250</span>
              </div>
            </Col>
          </div>
        )}
        <div className="row mb-2 mt-4 ajusteInput">
          <Col xs="4" md="4" lg="4"></Col>
          <Col xs="8" md="8" lg="8">
            <span>
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() => {
                  handleGuardarAspectoEvaluar();
                }}>
                Guardar
              </button>
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() => {
                  onClose();
                }}>
                Cancelar
              </button>
            </span>
          </Col>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
